<div class="height-100 overflow-hidden" fxLayout="column">
   <mat-toolbar mat-subheader fxLayoutAlign="space-between center">
      {{ 'LABEL_COMPANIES' | translate }}
      <div>
         <button id="id_close_form_btn" mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)='dialogRef.close()'>
            <mat-icon svgIcon="close"></mat-icon>
         </button>
      </div>
   </mat-toolbar>

   <ng-container>
      <mat-nav-list 
         fxLayout="column" 
         class="height-100 overflow-auto"
         infiniteScroll
         (scrolled)="getMore()"
         [scrollWindow]="false">
         <mat-list-item *ngFor="let company of companies" (click)="changeSchema(company)">
            <mat-label>{{company.description}}</mat-label>
         </mat-list-item>
      </mat-nav-list>
   </ng-container>

   <div *ngIf="loading.detail" class="height-100" fxLayoutAlign="center center">
      <mat-spinner></mat-spinner>
   </div>
</div>